import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { ADVANCE_ADJUSTMENT_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const AdvanceAdjustmentApi = createApi({
  reducerPath: "AdvanceAdjustment",
  baseQuery,
  tagTypes: ["AdvanceAdjustment"],
  endpoints: (builder) => ({
    getAdvanceAdjustment: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: ADVANCE_ADJUSTMENT_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: ADVANCE_ADJUSTMENT_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["AdvanceAdjustment"],
    }),
    getAdvanceAdjustmentById: builder.query({
      query: (id) => {
        return {
          url: `${ADVANCE_ADJUSTMENT_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["AdvanceAdjustment"],
    }),
    addAdvanceAdjustment: builder.mutation({
      query: (payload) => ({
        url: ADVANCE_ADJUSTMENT_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["AdvanceAdjustment"],
    }),
    updateAdvanceAdjustment: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${ADVANCE_ADJUSTMENT_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["AdvanceAdjustment"],
    }),
    deleteAdvanceAdjustment: builder.mutation({
      query: (id) => ({
        url: `${ADVANCE_ADJUSTMENT_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AdvanceAdjustment"],
    }),
  }),
});

export const {
  useGetAdvanceAdjustmentQuery,
  useGetAdvanceAdjustmentByIdQuery,
  useAddAdvanceAdjustmentMutation,
  useUpdateAdvanceAdjustmentMutation,
  useDeleteAdvanceAdjustmentMutation,
} = AdvanceAdjustmentApi;

export default AdvanceAdjustmentApi;
